module.exports = require("./fr-BE.d.ts");